export enum Sizes {
  // Default
  MAX_SHORT_TEXT = 50,
  MAX_LINK = 500,

  // User
  MIN_USER_PASSWORD_LENGTH = 6,
  MAX_USER_FIRST_NAME = 50,
  MAX_USER_LAST_NAME = 100,

  // Insole model
  MAX_INSOLE_MODEL_NAME = 100,
  MAX_INSOLE_MODEL_FILE_BYTES = 20971520,
  MAX_INSOLE_MODEL_PREVIEW_BYTES = 5242880,
}
